import { useLocation, useNavigate } from 'react-router-dom';
import { useRef, useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumb from '../../../../component/BreadCrumb';
import {
    CODE_GROUP_ID,
    COMMUNITY_QNA_ADD_PATH,
    COMMUNITY_QNA_DETAIL_PATH,
    PATH_DELIMITER,
    ROLE,
} from '../../../../constant/Constant';
import CodeUtil from '../../../../util/CodeUtil';
import InputBox from '../../../../component/InputBox';
import RegistButtonBox from '../../../../component/buttons/RegistButtonBox';
import { actionSearch } from '../../../../module/body/community/qna/CommunityQnaModule';
import { VIEW_COMMUNITY_QNA } from '../../../../constant/ViewConstant';
import SearchButtonBox from '../../../../component/buttons/SearchButtonBox';
import AuthenticationUtil from '../../../../util/AuthenticationUtil';
import PopupRef from '../../../../component/PopupRef';
import ModalRef from '../../../../component/ModalRef';
import { defaultGridData, handleControl, initGrid } from '../../../../module/component/TableBoxModule';
import TableBox from '../../../../component/TableBox';
import SelectionBox from '../../../../component/SelectionBox';
import { IconButton, Tooltip } from '@material-ui/core';
import { OpenDetailIcon } from '../../../../component/icon/GridIcons';
import PathUtil from '../../../../util/PathUtil';
import qs from 'qs';
import NullCheckUtil from '../../../../util/NullCheckUtil';

const ConditionArea = ({ popupRef, modalRef }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const addPermission =
        (NullCheckUtil.isNotEmpty(AuthenticationUtil.getUserRoleCd()) &&
            AuthenticationUtil.getUserRoleCd() == ROLE.ADMIN) ||
        AuthenticationUtil.getUserRoleCd() == ROLE.STAFF ||
        AuthenticationUtil.getUserRoleCd() == ROLE.STUDENT;
    const [answerUniversityCd, setAnswerUniversityCd] = useState('');
    const [postingTitleNm, setPostingTitleNm] = useState('');
    const [params, setParams] = useState({});

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { gridData } = useSelector((state) => state.tableBoxState);

    // 최초 초기화 호출
    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );

        queryData.postingTitleNm && setPostingTitleNm(queryData.postingTitleNm);
        queryData.answerUniversityCd && setAnswerUniversityCd(queryData.answerUniversityCd);

        onClickSearch({
            postingTitleNm: queryData.postingTitleNm,
            answerUniversityCd: queryData.answerUniversityCd,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 10,
        });

        return () => {
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );
    }, [params]);

    const onChangePageInfo = (page, pageSize) => {
        onClickSearch({
            ...params,
            page,
            pageSize,
        });
    };

    // button action - search
    const onClickSearch = (params) => {
        setParams(params);
        dispatch(
            actionSearch({
                params,
                callback: (result) => {
                    if (result.totalCount == 0) {
                        popupRef.current.openAlert('조회된 결과가 없습니다.');
                    }
                },
            }),
        );
        PathUtil.pushState(location.pathname, params);
    };

    const onRowDoubleClick = (row, params) => {
        let readPermission = false;
        if (row.postingTypeCd == 'CONFIDENTIAL') {
            if (
                AuthenticationUtil.getUserId() == row.regUserId ||
                AuthenticationUtil.getUserRoleCd() == ROLE.ADMIN ||
                AuthenticationUtil.getUserRoleCd() == ROLE.STAFF
            ) {
                readPermission = true;
            }
        } else {
            readPermission = true;
        }

        if (readPermission) {
            var path = COMMUNITY_QNA_DETAIL_PATH + PATH_DELIMITER + row.postingNo;
            navigate(path);
        } else {
            popupRef.current.openAlert('게시물 열람 권한이 없습니다.');
        }
    };

    const handleAdd = () => {
        navigate(COMMUNITY_QNA_ADD_PATH);
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClickSearch({
                postingTitleNm,
                answerUniversityCd,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    const columns = useMemo(
        () => [
            {
                field: 'postingNo',
                headerName: '번호',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 2,
            },
            {
                field: 'postingTitleNm',
                headerName: '제목',
                headerAlign: 'center',
                align: 'left',
                tooltip: true,
                flex: 10,
                renderCell: (params) => (
                    <div>
                        <span
                            className={params.row.answerStatusCd == 'ANSWER' ? 'answer-mark blue' : 'answer-mark red'}
                        >
                            {params.row.answerStatusCd != undefined
                                ? CodeUtil.getCodeName(CODE_GROUP_ID.ANSWER_STATUS, params.row.answerStatusCd)
                                : params.row.answerStatusCd}
                        </span>
                        {params.row.postingTitleNm}
                        <span className={params.row.postingTypeCd == 'CONFIDENTIAL' ? 'ico-lock' : ''}></span>
                    </div>
                ),
            },
            {
                field: 'answerUniversityCd',
                headerName: '문의담당 대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 3,
                renderCell: (params) => {
                    params.row.answerUniversityCd &&
                        CodeUtil.getCodeName(CODE_GROUP_ID.MAIN_UNIVERSITY, params.row.answerUniversityCd);
                },
            },
            {
                field: 'userNm',
                headerName: '문의자',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 3,
            },
            {
                field: 'regDttm',
                headerName: '등록일',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 5,
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 2,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='상세'>
                            <IconButton onClick={() => onRowDoubleClick(item.row, params)}>
                                <OpenDetailIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [params],
    );

    return (
        <>
            <div className='con-form-wrap '>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='search-condition-box'>
                                <div className='form-box-container'>
                                    <SelectionBox
                                        title='문의담당 대학'
                                        w140
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                                        value={answerUniversityCd}
                                        onChange={(e) => setAnswerUniversityCd(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e, params)}
                                    />
                                    <InputBox
                                        title='제목'
                                        value={postingTitleNm}
                                        onChange={(e) => setPostingTitleNm(e.target.value)}
                                        size='w-420'
                                        onKeyDown={(e) => onKeyDown(e, params)}
                                    />
                                </div>
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) =>
                                        onClickSearch({
                                            postingTitleNm,
                                            answerUniversityCd,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='con-tb-wrap'>
                <div className='con-tb-title  '>
                    <h3 className='tb-tit-name'>질의응답 목록</h3>
                    {addPermission && <RegistButtonBox title='등록' btnCommon onClick={(e) => handleAdd()} />}
                </div>
            </div>
        </>
    );
};

const CommunityQnaView = () => {
    const popupRef = useRef(null);
    const modalRef = useRef(null);

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg02'>
                    {/* <h2 className='con-title'>질의응답</h2> */}
                    <h2 className='con-title'>{VIEW_COMMUNITY_QNA.title}</h2>
                    <p className='con-title-p'>{VIEW_COMMUNITY_QNA.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <ConditionArea popupRef={popupRef} modalRef={modalRef} />
                <TableBox isSupportedWide={false} />
            </div>
            <ModalRef ref={modalRef} />
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default CommunityQnaView;
